import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface HeaderAndCloseButtomProps {
  closeAction: () => void;
  leftHeading: string;
  rightChildren?: React.ReactNode;
}

const HeaderAndCloseButtom: FC<HeaderAndCloseButtomProps> = ({
  closeAction,
  leftHeading,
  rightChildren,
}) => {
  return (
    <Grid
      xs={12}
      item
      display="flex"
      justifyContent="space-between"
      p={2}
      sx={{ border: `1px solid ${WsColors.TertiaryShades100}` }}
    >
      <Grid item>
        <Grid display="flex" direction="row" columnGap={1} alignItems="center">
          <CloseIcon
            sx={{ cursor: 'pointer', color: WsColors.TertiaryShades900, fontSize: 24 }}
            onClick={closeAction}
          />
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold={true}>
            {leftHeading}
          </WsTypography>
        </Grid>
      </Grid>
      <Grid item display="flex" flexDirection="column" alignItems="center">
        {rightChildren}
      </Grid>
    </Grid>
  );
};

export default HeaderAndCloseButtom;
